// Module
var code = `<div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
</div>
<div class="modal-body" amt-json-editor ng-model="model.model" options="jsoneditor_options" style="height: 600px;"></div>
<div class="modal-footer">
    <button class="btn btn-primary" ng-disabled="!can_save" ng-click="save()" title="{{can_not_save_reason}}">Save</button>
    <button class="btn btn-warning" ng-click="cancel()">Cancel</button>
</div>`;
// Exports
module.exports = code;